import { render, staticRenderFns } from "./ReLeadTableCopy.vue?vue&type=template&id=41b0a35e&scoped=true"
import script from "./ReLeadTableCopy.vue?vue&type=script&lang=js"
export * from "./ReLeadTableCopy.vue?vue&type=script&lang=js"
import style0 from "./ReLeadTableCopy.vue?vue&type=style&index=0&id=41b0a35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b0a35e",
  null
  
)

export default component.exports